import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/global.css';

// Use a plain axios call here (not the shared client `api`): the shared instance
// redirects to the CLIENT login on any 401, which was bouncing a failed staff
// login onto the client dashboard instead of showing the error on this page.
const API_URL = process.env.REACT_APP_API_URL || 'https://zippy-flexibility-production.up.railway.app';

export default function StaffLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/staff/login`, { email, password });
      localStorage.setItem('staffToken', res.data.token);
      navigate('/staff');
    } catch {
      setError('Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      background: '#3d7370',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px'
    }}>
      <div style={{ marginBottom: '24px', fontFamily: 'Nunito, sans-serif', fontWeight: 800, fontSize: '24px', color: 'white' }}>
        BUMP <span style={{ color: '#F68F7C' }}>&#x2665;&#xFE0E;</span> BABY IMAGING
      </div>

      <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: '100px', padding: '6px 16px', fontSize: '12px', fontWeight: 700, color: 'white', fontFamily: 'Nunito, sans-serif', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '24px' }}>
        <div style={{ width: '8px', height: '8px', background: '#F68F7C', borderRadius: '50%' }} />
        Staff Access Only
      </div>

      <div className="card" style={{ maxWidth: '420px', width: '100%' }}>
        <h2 style={{ fontFamily: 'Nunito, sans-serif', fontWeight: 800, fontSize: '22px', color: 'var(--teal-dark)', marginBottom: '6px' }}>Staff Login</h2>
        <p style={{ fontSize: '14px', color: 'var(--text-soft)', marginBottom: '28px', lineHeight: '1.5' }}>
          This area is for Bump Baby Imaging staff only.
        </p>
        {error && <p style={{ color: 'var(--coral-dark)', fontSize: '13px', marginBottom: '16px', background: 'var(--coral-light)', padding: '10px 14px', borderRadius: '8px' }}>{error}</p>}
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Email Address</label>
            <input type="email" placeholder="your@bumpbabyimaging.com.au" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                style={{ width: '100%', paddingRight: '46px' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(s => !s)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                title={showPassword ? 'Hide password' : 'Show password'}
                style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center', color: 'var(--text-soft)' }}
              >
                {showPassword ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                )}
              </button>
            </div>
          </div>
          <button className="btn-primary" type="submit" disabled={loading}>{loading ? 'Logging in...' : 'Log In to Dashboard'}</button>
        </form>
        <p style={{ textAlign: 'center', marginTop: '16px', fontSize: '13px' }}>
          <span style={{ color: 'var(--teal)', cursor: 'pointer', fontWeight: 700 }}>Forgot your password?</span>
        </p>
      </div>

      <footer style={{ marginTop: '32px', fontSize: '12px', color: 'rgba(255,255,255,0.6)', textAlign: 'center' }}>
        <p>Made with <span style={{ color: '#F68F7C' }}>&#x2665;&#xFE0E;</span> by Bump Baby Imaging</p>
      </footer>
    </div>
  );
}
